import React from "react";

function vehicleNotFound() {
  return (
    <div className="col-md-8 col-md-offset-2 takataRecall ">
      <div className="carDetails">
        <div className="carDetails__wrap">
          <h2 className="carDetails__heading h5">Vehicle Not Found</h2>
          <p className="carDetails__statusMessage ">
            We have no record of this VIN/registration number in our system. Please double check the VIN (Vehicle
            Identification Number) or registration number and state/territory entered.If this vehicle is not a Subaru
            vehicle, please visit the Australian website of the relevant manufacturer.If this vehicle is a Subaru
            vehicle, it may have been imported into Australia by a third party. In this case please contact our
            dedicated Recall Contact Centre on <strong>1300 550 994</strong> or email{" "}
            <a href="mailto:feedback@subaru.com.au">feedback@subaru.com.au</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default vehicleNotFound;
